import React from 'react';
import { object, number } from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { contextPropTypes } from '../../../../../proptypes/shared';
import styles from './styles/styles.module.scss';
import TrackResultCard from '../../../../../components/cards/TrackResultCard';
import useReduxListItems from '../../../hooks/useReduxListItems';

const CommunityTrackCard = ({ context, track, idx }) => {
  const { listItems } = useSelector(state => state.lists, shallowEqual);
  const { isFavorite, handleFavoriteClick } = useReduxListItems(track, listItems);

  return (
    <TrackResultCard
      className={styles.trailResultCard}
      imageCarouselClassName={styles.imageCarousel}
      context={context}
      handleAddToListClick={() => {}}
      handleCardClick={() => {}}
      handleFavoriteClick={handleFavoriteClick}
      idx={idx}
      isFavorite={isFavorite}
      key={`track-${track.ID}`}
      showFavoriteHeart
      tabletBrowser={context.tabletBrowser}
      track={track}
    />
  );
};

CommunityTrackCard.propTypes = {
  context: contextPropTypes.isRequired,
  track: object.isRequired,
  idx: number
};

CommunityTrackCard.defaultProps = {
  idx: 0
};

export default CommunityTrackCard;
